import { useState, useEffect, useRef } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import PromoCodeList from 'components/Lists/PromoCodeList'
import AddPromoCodeModal from 'pages/Admin/Modals/AddPromoCodeModal'
import TextInput from 'components/Inputs/TextInput'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'

import { ListContainer, FilterContainer } from '../styles'

export default function PromoCodes () {
  const [query, setQuery] = useState ('')
  const [loading, setLoading] = useState (true)
  const [promoCodes, setPromoCodes] = useState ([])
  const [showAddPromoCodeModal, setShowAddPromoCodeModal] = useState (false)
  const token = AuthService.getToken ()
  const debounceTimeout = useRef ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    if (debounceTimeout.current) clearTimeout (debounceTimeout.current)
    
    debounceTimeout.current = setTimeout (() => {
      getData ()
    }, 500)

    return () => clearTimeout (debounceTimeout.current)
  }, [query])

  const getData = async () => {
    try {
      setLoading (true)

      const { data: promoCodes } = await cutileiApi.get (
        `/promo_codes?code=${query}`, requestConfig
      )

      setPromoCodes (promoCodes)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleAddPromoCodeModal = () => setShowAddPromoCodeModal (!showAddPromoCodeModal)

  return (
    <ListContainer>
      <FilterContainer>
        <TextInput
          value={query}
          placeholder='Pesquisar por código'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => setQuery ('')}
          containerStyle={{width: 280}}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
        <SecondaryButton
          label='Novo cupom'
          leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 2}}/>}
          onClick={toggleAddPromoCodeModal}
          width={140}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> : (
        <PromoCodeList
          promoCodes={promoCodes}
          onEdit={promoCode => setPromoCodes (promoCodes.map (pc => pc.id === promoCode.id ? promoCode : pc))}
          onDelete={promoCode => setPromoCodes (promoCodes.filter (pc => pc.id !== promoCode.id))}
        />
      )}
      <AddPromoCodeModal
        visible={showAddPromoCodeModal}
        onConfirm={promoCode => setPromoCodes ([promoCode, ...promoCodes])}
        onClose={toggleAddPromoCodeModal}
      />
    </ListContainer>
  )
}
